import { Navigate, useParams } from "react-router-dom";

/** 访问 /space/:spaceId 时重定向到空间首页 */
export function SpaceEntryRedirect() {
  const { spaceId } = useParams<{ spaceId: string }>();
  if (!spaceId) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/space/${spaceId}/home`} replace />;
}
